import React from 'react'
import { IconTypeProps } from '../icon';

export function IconDropdown({
  onClick = () => {},
  className = '',
  ...rest
}: IconTypeProps) {
  return (
    <svg
      onClick={onClick}
      className={className}
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0.0749225 0.357333C0.0188284 0.465176 -0.00683692 0.58626 0.000679939 0.707588C0.00819679 0.828915 0.0486116 0.945904 0.117589 1.046L6.11759 9.71267C6.17894 9.80123 6.26085 9.8736 6.35628 9.92358C6.45172 9.97356 6.55785 9.99967 6.66559 9.99967C6.77332 9.99967 6.87946 9.97356 6.97489 9.92358C7.07033 9.8736 7.15223 9.80123 7.21359 9.71267L13.2136 1.046C13.2828 0.945983 13.3233 0.828939 13.3308 0.707542C13.3382 0.586146 13.3123 0.465022 13.2559 0.357286C13.1995 0.249551 13.1146 0.159309 13.0106 0.0963313C12.9065 0.0333539 12.7872 4.10317e-05 12.6656 -2.00757e-08L0.665589 -5.44612e-07C0.543898 -2.06039e-05 0.424521 0.0332681 0.320401 0.0962576C0.21628 0.159247 0.131388 0.249534 0.0749225 0.357333Z"
      />
    </svg>

  );
}
